$shm_hitalama_text_editor $mol_textarea
	owner $giper_baza_entity
	images_enabled true
	auto /
		^
		<= paste_listener null
